import React, { useEffect, useState, useMemo } from "react";
import * as Yup from "yup";
import {
    useFormik,
    FormikProvider,
    Form,
    Field,
    ErrorMessage,
} from "formik";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { successAlertRefresh } from "../CommonUtils/SweetAlerts";
import { useNavigate } from "react-router-dom";



const DesignationBlock = ({ title, prefix, deptname, userId }) => (

    <>
        <h5 className="mb-3 innerheader-new"><span>{title} </span>Details   (At the time of Appointment)</h5>


        <bie.Row>
            <bie.Col lg={4}>
                <label>Department</label>
                <Field as="select" name={`${prefix}.deptName`} className="form-control">
                    <option value="">--Select--</option>
                    {deptname?.map((d) => (
                        <option key={d.dept_id} value={d.dept_id}>
                            {d.dept_name}
                        </option>
                    ))}
                </Field>
                <ErrorMessage name={`${prefix}.deptName`} component="div" className="text-danger" />
            </bie.Col>

            {[
                {
                    name: "sanctionedPosts",
                    label: "Sanctioned posts (GO Ms No 95 dt 16-09-2023)"
                },
                {
                    name: "regularFaculty",
                    label: "No of regular faculty working"
                },
                {
                    name: "contractFaculty",
                    label: "No of contract faculty working"
                },
                ...(prefix === "associateProfessor"
                    ? [
                        {
                            name: "academicConsultant",
                            label: "No of Academic Consultants"
                        }
                    ]
                    : []),


                ...(userId === "U-0632_maker"
                    ? [
                        {
                            name: "rguktMentor",
                            label: "No of RGUKT Mentors"
                        }
                    ]
                    : []),
                {
                    name: "guestFaculty",
                    label: "No of Guest faculty working"
                },
                {
                    name: "adhocFaculty",
                    label: "No of Adhoc faculty working"
                }
            ].map(({ name, label }) => (
                <bie.Col lg={4} className="mb-3" key={name}>
                    <label>{label}</label>
                    <Field
                        name={`${prefix}.${name}`}
                        type="text"
                        className="form-control"
                        maxLength={4}
                    />
                    <ErrorMessage
                        name={`${prefix}.${name}`}
                        component="div"
                        className="text-danger"
                    />
                </bie.Col>
            ))}
        </bie.Row>

    </>
);

export default function SubjectWiseFacultyData() {
    const userId = sessionStorage.getItem("user_id");

    const fields = [
        "deptName",
        "sanctionedPosts",
        "regularFaculty",
        "contractFaculty",
        "guestFaculty",
        "adhocFaculty",
        ...(userId === "U-0632_maker" ? ["rguktMentor"] : []),

    ];


    const blockValidation = Yup.object().shape({
        deptName: Yup.string().nullable(),
        sanctionedPosts: Yup.string().nullable(),
        regularFaculty: Yup.string().nullable(),
        contractFaculty: Yup.string().nullable(),
        guestFaculty: Yup.string().nullable(),
        adhocFaculty: Yup.string().nullable(),

    }).test("complete-block", null, function (value) {
        const { path, createError } = this;

        if (!value) return true;



        const anyFilled = fields.some((f) => value[f] && value[f] !== "");
        const allFilled = fields.every((f) => value[f] && value[f] !== "");

        if (anyFilled && !allFilled) {
            const emptyField = fields.find((f) => !value[f] || value[f] === "");
            return createError({
                path: `${path}.${emptyField}`,
                message: "Required",
            });
        }

        return true;
    });

    const validationSchema = Yup.object({
        professor: blockValidation,
        associateProfessor: Yup.object().shape({
            deptName: Yup.string().nullable(),
            sanctionedPosts: Yup.string().nullable(),
            regularFaculty: Yup.string().nullable(),
            contractFaculty: Yup.string().nullable(),
            academicConsultant: Yup.string().nullable(),
            guestFaculty: Yup.string().nullable(),
            adhocFaculty: Yup.string().nullable(),

        }).test("complete-block", null, function (value) {

            const { path, createError } = this;

            if (!value) return true;

            const fields = [
                "deptName",
                "sanctionedPosts",
                "regularFaculty",
                "contractFaculty",
                "academicConsultant",
                ...(userId === "U-0632_maker" ? ["rguktMentor"] : []),
                "guestFaculty",
                "adhocFaculty",
            ];

            const anyFilled = fields.some((f) => value[f] && value[f] !== "");
            const allFilled = fields.every((f) => value[f] && value[f] !== "");

            if (anyFilled && !allFilled) {

                const emptyField = fields.find(
                    (f) => !value[f] || value[f] === ""
                );

                return createError({
                    path: `${path}.${emptyField}`,
                    message: "Required",
                });
            }

            return true;
        }),

        assistantProfessor: blockValidation,
        lecturer: blockValidation,
    }).test(
        "at-least-one-block",
        "At least one designation block must be completed",
        function (values) {
            const isComplete = (block, isAssociate = false) => {
                const fields = [
                    block?.deptName,
                    block?.sanctionedPosts,
                    block?.regularFaculty,
                    block?.contractFaculty,
                    // block?.academicConsultant,
                    // ...(userId === "U-0632_maker" ? [block?.rguktMentor] : []),
                    ...(isAssociate ? [block?.academicConsultant] : []),
                    ...(userId === "U-0632_maker"
                        ? [block?.rguktMentor]
                        : []),

                    block?.guestFaculty,
                    block?.adhocFaculty,
                ];
                return fields.every((f) => f && f !== "");
            };

            if (
                isComplete(values.professor) ||
                isComplete(values.associateProfessor) ||
                isComplete(values.assistantProfessor) ||
                isComplete(values.lecturer) ||
                isComplete(values.associateProfessor, true)

            ) {
                return true;
            }

            return false;
        }
    );
    const [deptname, setDeptname] = useState([]);
    let navigate = useNavigate();
    const getDeptList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getDept`
        );
        setDeptname(res?.data?.scode === "01" ? res.data.data : []);
    };
    useEffect(() => {
        getDeptList();
    }, []);
    const initialValues = useMemo(
        () => ({
            professor: {
                deptName: "",
                sanctionedPosts: "",
                regularFaculty: "",
                contractFaculty: "",
                guestFaculty: "",
                adhocFaculty: "",
                rguktMentor: "",

            },
            associateProfessor: {
                deptName: "",
                sanctionedPosts: "",
                regularFaculty: "",
                contractFaculty: "",
                guestFaculty: "",
                adhocFaculty: "",
                rguktMentor: "",

            },
            assistantProfessor: {
                deptName: "",
                sanctionedPosts: "",
                regularFaculty: "",
                contractFaculty: "",
                guestFaculty: "",
                adhocFaculty: "",
                academicConsultant: "",
                rguktMentor: "",


            },
            lecturer: {
                deptName: "",
                sanctionedPosts: "",
                regularFaculty: "",
                contractFaculty: "",
                guestFaculty: "",
                adhocFaculty: "",
                rguktMentor: "",

            },

        }),
        []
    );

    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (values) => {
            const deptDetailsList = [];

            const pushIfFilled = (data, designation) => {
                if (data.deptName) {
                    deptDetailsList.push({
                        deptName: data.deptName,
                        noOfSanPosts: data.sanctionedPosts,
                        noOfRegFacWorking: data.regularFaculty,
                        noOfContractFacWorking: data.contractFaculty,
                        noOfGuestFacWorking: data.guestFaculty,
                        noOfAdhocFacWorking: data.adhocFaculty,
                        academicConsultant: data.academicConsultant,
                        rguktMentor: data.rguktMentor,

                        designation,
                    });
                }
            };

            pushIfFilled(values.professor, "Professor");
            pushIfFilled(values.associateProfessor, "Associate Professor");
            pushIfFilled(values.assistantProfessor, "Assistant Professor");
            pushIfFilled(values.lecturer, "lecturer");

            if (!deptDetailsList.length) {
                Swal.fire("Fill at least one block", "", "warning");
                return;
            }

            console.log("FINAL PAYLOAD 👉", { deptDetailsList });


            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to Submit?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Submit!",
            }).then((result) => {
                if (result.isConfirmed) {
                    // const payloads = [
                    //     buildPayload("Professor", values.professor),
                    //     buildPayload("Assistant Professor", values.assistantProfessor),
                    // ];

                    const url = `${config.url.FAC_URL}saveSubjectFacData`;
                    CommonAxiosPost(url, { deptDetailsList })
                        .then((res) => {
                            console.log("res?.data>>", res?.data);
                            if (res?.data?.scode === "01") {
                                // Swal.fire(res?.data?.sdesc, "", "success").then(() => {
                                //     facultySubjectDetailsFormik.resetForm();
                                // });
                                successAlertRefresh(res?.data?.sdesc);

                            } else {
                                Swal.fire(res?.data?.sdesc || "Submission failed", "", "error");
                            }
                        });

                }
            });
        },
    });
    console.log("DEPT NAME 👉", formik?.errors);

    return (
        <>

            <div className='faculty-card'>
                <div className='fac-topbar'>

                    <div className='fac-detnew'>
                        <h5 className='mb-0'>Department Details</h5>
                    </div>

                    <button type="button"
                        className='newfacbtn'
                        onClick={() => navigate("/UniversitySubjectFacReport")}>
                        University Faculty Details
                    </button>
                </div >



                <div className="faculty-form-wrapper">
                    <div className="">
                        <FormikProvider value={formik}>
                            <Form>
                                <DesignationBlock
                                    title="Professor"
                                    prefix="professor"
                                    deptname={deptname}
                                    userId={userId}
                                />

                                <DesignationBlock
                                    title="Associate Professor"
                                    prefix="associateProfessor"
                                    deptname={deptname}
                                    userId={userId}
                                />
                                <DesignationBlock
                                    title="Assistant Professor"
                                    prefix="assistantProfessor"
                                    deptname={deptname}
                                    userId={userId}
                                />
                                {userId === "U-0632_maker" &&
                                    <DesignationBlock
                                        title="Lecturer"
                                        prefix="lecturer"
                                        deptname={deptname}
                                        userId={userId}
                                    />
                                }


                                <div className="text-end mt-3">
                                    <button type="submit" className="btn btn-sm submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </Form>
                        </FormikProvider>
                    </div>
                </div>
            </div>
        </>
    );
}